import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// Planked wooden crate — outdoor twin of structure furniture crate.
const build: (ctx: DecoBuildCtx) => void = ({ box, seed }) => {
  const wood = shade(0x7a5c3a, (rand(seed) - 0.5) * 0.12);
  const lt = shade(wood, 0.12);
  const dk = shade(wood, -0.14);
  const s = 0.85 + rand(seed + 1) * 0.2;
  box(0, s / 2, 0, s, s, s, dk);
  box(0, s - 0.04, 0, s * 1.02, 0.1, s * 1.02, lt);
  box(0, 0.05, 0, s * 1.02, 0.1, s * 1.02, lt);
  box(0, s / 2, 0, s * 1.01, s * 0.14, s * 0.14, wood);
  box(0, s / 2, 0, s * 0.14, s * 0.14, s * 1.01, wood);
};

export default build;
